import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lk-irc-login-wrapper-embed" }
const _hoisted_2 = { class: "lk-irc-embed-input" }
const _hoisted_3 = { class: "lk-irc-embed-input margin-top" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "lk-irc-embed-fst-login-tip" }, "首次登录平台请修改密码：", -1)
const _hoisted_6 = { class: "lk-irc-embed-input" }
const _hoisted_7 = { class: "lk-irc-embed-input margin-top" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("修改密码")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.fstLogin)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_input, {
              class: _normalizeClass({error: _ctx.fstInputError}),
              value: _ctx.username,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
              autocomplete: "off",
              placeholder: "请输入HIS系统用户名/手机号"
            }, null, 8, ["class", "value"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_input, {
              class: _normalizeClass({error: _ctx.sedInputError}),
              value: _ctx.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              autocomplete: "off",
              type: "password",
              placeholder: "请输入密码"
            }, null, 8, ["class", "value"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass({'lk-irc-embed-error-tip': true, 'error': _ctx.showError})
          }, _toDisplayString(_ctx.errMsg), 3),
          _createVNode(_component_a_button, {
            style: {"width":"100%","height":"40px"},
            type: "primary",
            onClick: _ctx.login
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", {
            style: {"text-align":"right","color":"rgba(0,0,0,0.65)","margin-top":"16px","cursor":"pointer","user-select":"none"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.forgetPassword && _ctx.forgetPassword(...args)))
          }, "忘记密码？")
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_input, {
              class: _normalizeClass({error: _ctx.fstInputError}),
              value: _ctx.newpass,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newpass) = $event)),
              autocomplete: "off",
              type: "password",
              placeholder: "请输入新密码"
            }, null, 8, ["class", "value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_a_input, {
              class: _normalizeClass({error: _ctx.sedInputError}),
              value: _ctx.newpassagain,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newpassagain) = $event)),
              autocomplete: "off",
              type: "password",
              placeholder: "请确认新密码"
            }, null, 8, ["class", "value"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass({'lk-irc-embed-error-tip': true, 'error': _ctx.showError})
          }, _toDisplayString(_ctx.errMsg), 3),
          _createVNode(_component_a_button, {
            style: {"width":"100%","height":"40px"},
            type: "primary",
            onClick: _ctx.login
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 64))
  ]))
}